import React from "react";
import useBasketMassManagement from "../../../../../hooks/shared/useBasketMassManagement";
import IconExclamation from "../../../../../../../../common-deprecated/svg/toyota/exclamation.svg";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketMassManagement";

const BasketMassManagement = (): JSX.Element | null => {
    const { visible, labels, openMassManagementModal } = useBasketMassManagement();

    if (!visible || !labels) return null;
    return (
        <Styles.Wrapper>
            {labels.start}
            {labels.link && (
                <a
                    href="src/new-cars/original/buildandbuy/components/toyota/common/basket/content#"
                    onClick={openMassManagementModal}
                >
                    {labels.link}
                </a>
            )}
            <IconExclamation />
            {labels.end}
        </Styles.Wrapper>
    );
};

export default BasketMassManagement;
